"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MenuItemIcon = exports.MenuItem = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _react = _interopRequireDefault(require("react"));
var _fonts = require("../fonts");
var _Svg = require("../Svg");
var _excluded = ["icon", "title", "subtitle", "className"];
var _templateObject, _templateObject2, _templateObject3;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var arrowRotate = function arrowRotate(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M10 15V13H3.41L15 1.41L13.59 0L2 11.59V5H0V15H10Z",
    fill: "currentColor"
  }));
};
arrowRotate.defaultProps = {
  width: "15",
  height: "15",
  viewBox: "0 0 15 15",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var wallet = function wallet(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M18 15V16C18 17.1 17.1 18 16 18H2C0.89 18 0 17.1 0 16V2C0 0.9 0.89 0 2 0H16C17.1 0 18 0.9 18 2V3H9C7.89 3 7 3.9 7 5V13C7 14.1 7.89 15 9 15H18ZM9 13H19V5H9V13ZM13 10.5C12.17 10.5 11.5 9.83 11.5 9C11.5 8.17 12.17 7.5 13 7.5C13.83 7.5 14.5 8.17 14.5 9C14.5 9.83 13.83 10.5 13 10.5Z",
    fill: "currentColor"
  }));
};
wallet.defaultProps = {
  width: "19",
  height: "18",
  viewBox: "0 0 19 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var history = function history(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M15 15.5H3V13.5H15V15.5ZM15 11.5H3V9.5H15V11.5ZM15 7.5H3V5.5H15V7.5ZM0 20.5L1.5 19L3 20.5L4.5 19L6 20.5L7.5 19L9 20.5L10.5 19L12 20.5L13.5 19L15 20.5L16.5 19L18 20.5V0.5L16.5 2L15 0.5L13.5 2L12 0.5L10.5 2L9 0.5L7.5 2L6 0.5L4.5 2L3 0.5L1.5 2L0 0.5V20.5Z",
    fill: "currentColor"
  }));
};
history.defaultProps = {
  width: "18",
  height: "21",
  viewBox: "0 0 18 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var settings = function settings(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M7.58579 2.89979L10.1928 0.292786C10.3803 0.105315 10.6346 0 10.8998 0C11.165 0 11.4193 0.105315 11.6068 0.292786L14.2138 2.89979H17.8998C18.165 2.89979 18.4194 3.00514 18.6069 3.19268C18.7944 3.38022 18.8998 3.63457 18.8998 3.89979V7.58579L21.5068 10.1928C21.6943 10.3803 21.7996 10.6346 21.7996 10.8998C21.7996 11.165 21.6943 11.4193 21.5068 11.6068L18.8998 14.2138V17.8998C18.8998 18.165 18.7944 18.4194 18.6069 18.6069C18.4194 18.7944 18.165 18.8998 17.8998 18.8998H14.2138L11.6068 21.5068C11.4193 21.6943 11.165 21.7996 10.8998 21.7996C10.6346 21.7996 10.3803 21.6943 10.1928 21.5068L7.58579 18.8998H3.89979C3.63457 18.8998 3.38022 18.7944 3.19268 18.6069C3.00514 18.4194 2.89979 18.165 2.89979 17.8998V14.2138L0.292786 11.6068C0.105315 11.4193 0 11.165 0 10.8998C0 10.6346 0.105315 10.3803 0.292786 10.1928L2.89979 7.58579V3.89979C2.89979 3.63457 3.00514 3.38022 3.19268 3.19268C3.38022 3.00514 3.63457 2.89979 3.89979 2.89979H7.58579ZM10.8998 13.8998C11.6954 13.8998 12.4585 13.5837 13.0211 13.0211C13.5837 12.4585 13.8998 11.6954 13.8998 10.8998C13.8998 10.1041 13.5837 9.34107 13.0211 8.77847C12.4585 8.21586 11.6954 7.89979 10.8998 7.89979C10.1041 7.89979 9.34107 8.21586 8.77847 8.77847C8.21586 9.34107 7.89979 10.1041 7.89979 10.8998C7.89979 11.6954 8.21586 12.4585 8.77847 13.0211C9.34107 13.5837 10.1041 13.8998 10.8998 13.8998Z",
    fill: "#F4F4F9"
  }));
};
settings.defaultProps = {
  width: "22",
  height: "22",
  viewBox: "0 0 22 22",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var exit = function exit(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M1 20C0.734784 20 0.48043 19.8946 0.292893 19.7071C0.105357 19.5196 0 19.2652 0 19V1C0 0.734784 0.105357 0.48043 0.292893 0.292893C0.48043 0.105357 0.734784 0 1 0H15C15.2652 0 15.5196 0.105357 15.7071 0.292893C15.8946 0.48043 16 0.734784 16 1V4H14V2H2V18H14V16H16V19C16 19.2652 15.8946 19.5196 15.7071 19.7071C15.5196 19.8946 15.2652 20 15 20H1ZM14 14V11H7V9H14V6L19 10L14 14Z",
    fill: "#F4F4F9"
  }));
};
exit.defaultProps = {
  width: "19",
  height: "20",
  viewBox: "0 0 19 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var icons = {
  arrowRotate: arrowRotate,
  wallet: wallet,
  history: history,
  settings: settings,
  exit: exit
};
var Title = (0, _styledComponents.default)(_fonts.P)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  color: ", ";\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.secondary;
});
var Subtitle = (0, _styledComponents.default)(_fonts.Small)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  margin-top: 5px;\n  color: ", ";\n"])), function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.tertiaryShade;
});
var MenuItemIcon = function MenuItemIcon(_ref3) {
  var name = _ref3.name,
    rotate = _ref3.rotate;
  return /*#__PURE__*/_react.default.createElement(_Svg.Svg, {
    color: "lightPrimary",
    rotate: rotate,
    as: icons[name]
  });
};
exports.MenuItemIcon = MenuItemIcon;
var MenuItem = (0, _styledComponents.default)(function (_ref4) {
  var icon = _ref4.icon,
    title = _ref4.title,
    subtitle = _ref4.subtitle,
    className = _ref4.className,
    props = _objectWithoutProperties(_ref4, _excluded);
  return /*#__PURE__*/_react.default.createElement("div", _extends({
    className: "d-flex align-items-center ".concat(className)
  }, props), icon, /*#__PURE__*/_react.default.createElement("div", {
    className: "d-flex flex-column"
  }, /*#__PURE__*/_react.default.createElement(Title, null, title), subtitle && /*#__PURE__*/_react.default.createElement(Subtitle, null, subtitle)));
})(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  cursor: pointer;\n  padding: 10px 30px 10px 4px;\n  white-space: nowrap;\n  ", " {\n    margin-right: 14px;\n    flex: none;\n  }\n  div {\n    flex: none;\n  }\n"])), _Svg.Svg);
exports.MenuItem = MenuItem;